/* eslint-disable no-alert */

import { logError } from '../../services/loggerService';
import { isLoggedIn, getPageName, getCookie } from './Helpers';
import { ME_LANDING, MY_FEED, PROSPECT_3_0_DISCOVER } from './mvaViews';

// Returns whether a bridge actually took the message, so callers that have a
// browser equivalent can fall back when the page is not hosted in the app.
export const mvaBridgeApiCall = (bridgeAPIMsg) => {
  let posted = false;
  try {
    const bridgeAPIPostJson = JSON.stringify(bridgeAPIMsg);
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.mfAppInterface &&
      window.webkit.messageHandlers.mfAppInterface.postMessage
    ) {
      window.webkit.messageHandlers.mfAppInterface.postMessage(bridgeAPIPostJson);
      posted = true;
    }
    if (window.mfAppInterface && window.mfAppInterface.postMessage) {
      window.mfAppInterface.postMessage(bridgeAPIPostJson);
      posted = true;
    }
  } catch (err) {
    console.log(err);
  }
  return posted;
};

export const mvaLinkApiCall = (linkUrl) => {
  const bridgeAPIMsg = {
    actionType: 'openURL',
    pageType: 'openBrowser',
    browserUrl: linkUrl,
    openInWebview: true,
  };
  mvaBridgeApiCall(bridgeAPIMsg);
};

const emptyFunc = () => null;

export const triggerIsApplePaySupported = (callback) => {
  window.isApplePaySupportedCallback = callback || emptyFunc;
  const bridgeAPIMsg = {
    actionType: 'isApplePaySupported',
    jsCallback: 'window.isApplePaySupportedCallback',
  };
  // {"isSuccess":"Y","isApplePaySupported":"Y/N"}
  mvaBridgeApiCall(bridgeAPIMsg);
};

export const triggerApplePay = (merchantId, lineItems, callback) => {
  window.applePayCallback = callback;
  const bridgeAPIMsg = {
    actionType: 'applePayPayment',
    jsCallback: 'window.applePayCallback',
    lineItems,
    merchantId,
  };
  mvaBridgeApiCall(bridgeAPIMsg);
};

export const isMVA = () => window.navigator.userAgent.indexOf('MY_VZW_APP') > -1;

/*
 * Open/Share PDF web-to-native interaction. window.print() is a no-op inside the
 * WKWebView/Android WebView, so the app takes the whole document as a base64 PDF
 * and writes it to the device.
 *
 * `type` picks the Android intent and is fixed to a plain save — the download link
 * is not offering to email or print. iOS ignores the field.
 */
export const openPdfInMVA = (pdfString, fileName) => {
  if (!pdfString || !fileName) {
    return false;
  }
  return mvaBridgeApiCall({
    actionType: 'openPDF',
    pdfString,
    fileName,
    type: 'Save',
  });
};

export const resetNavigationTitle = (isMVAChannelFlag) => {
  if (isMVAChannelFlag) {
    // write below code only when it is APP.
    const bridgeAPIMsg = {
      actionType: 'updateNavigation',
      navigationBar: {
        moleculeName: 'navigationBar',
        title: 'Home Internet', // add title what is displayed in NSA (for BAU it is Home Internet)
        alwaysShowBackButton: false, // false if u  want to hide the back
      },
    };
    mvaBridgeApiCall(bridgeAPIMsg); // calling this will update the navigation title
  }
};

export const setNavigationTitle = (isMVAChannelFlag, title) => {
  if (isMVAChannelFlag) {
    // write below code only when it is APP.
    const bridgeAPIMsg = {
      actionType: 'updateNavigation',
      navigationBar: {
        moleculeName: 'navigationBar',
        title,
        alwaysShowBackButton: false, // false if u  want to hide the back
      },
    };
    console.log(bridgeAPIMsg, 'kk');
    mvaBridgeApiCall(bridgeAPIMsg); // calling this will update the navigation title
  }
};

export const renderNavBarCloseICON = (targetView) => {
  try {
    const action = {
      title: 'Close',
      actionType: 'openPage',
      pageType: targetView,
      analyticsData: {
        'vzdl.page.linkName': 'cross action',
        'vzdl.page.sourceChannel': 'MVA',
        'vzdl.page.displayChannel': 'MVA',
        'vzdl.page.id': '5G_confirmation',
        'vzdl.page.name': '5G_confirmation',
        'vzdl.page.pageTypeLinkname': '5G confirmation|cross action',
        'vzdl.page.webViewPage': getPageName(),
      },
    };

    if (targetView === ME_LANDING && getCookie('meLanding') === 'Y') {
      action.context = 'mobile/nsa/nos/gw/launchapp/';
    }

    const payLoad = {
      actionType: 'updateNavigation',
      navigationBar: {
        moleculeName: 'navigationBar',
        alwaysShowBackButton: true,
        backButton: {
          moleculeName: 'navigationImageButton',
          image: 'nav_close',
          action,
        },
      },
    };
    mvaBridgeApiCall(payLoad);
  } catch (mvaBridgeError) {
    logError('renderNavBarCloseICON-bridgeAPI', mvaBridgeError);
  }
};

export const renderConfirmationCloseICON = () => {
  if (isLoggedIn() && getCookie('meLanding') === 'Y') {
    return renderNavBarCloseICON(ME_LANDING);
  }
  if (isLoggedIn()) {
    return renderNavBarCloseICON(MY_FEED);
  }
  return renderNavBarCloseICON(PROSPECT_3_0_DISCOVER);
};
